var map = {
	"./天气-中到大雨.png": "GGvq",
	"./天气-中到大雪.png": "mi0A",
	"./天气-中雨.png": "nT8U",
	"./天气-中雪.png": "9ntK",
	"./天气-冻雨.png": "+oV8",
	"./天气-多云.png": "+Fp4",
	"./天气-大到暴雨.png": "4EuC",
	"./天气-大到暴雪.png": "eo1R",
	"./天气-大暴雨.png": "YcQO",
	"./天气-大雨.png": "KNpx",
	"./天气-大雪.png": "8I3B",
	"./天气-小到中雨.png": "VhAJ",
	"./天气-小到中雪.png": "BNRt",
	"./天气-小雨.png": "dGZE",
	"./天气-小雪.png": "YgBj",
	"./天气-强沙尘暴.png": "mkB/",
	"./天气-扬沙.png": "Vbzc",
	"./天气-晴.png": "H6CQ",
	"./天气-暴雨.png": "eJxj",
	"./天气-暴雨到大暴雨.png": "FNSv",
	"./天气-暴雪.png": "VrCV",
	"./天气-沙尘暴.png": "xx4a",
	"./天气-浮尘.png": "r6KD",
	"./天气-特大暴雨.png": "oT4w",
	"./天气-阴.png": "TCHX",
	"./天气-阵雨.png": "EKxZ",
	"./天气-阵雪.png": "og/g",
	"./天气-雨.png": "0iYZ",
	"./天气-雨夹雪.png": "b7Du",
	"./天气-雪.png": "O23X",
	"./天气-雷阵雨.png": "tPOs",
	"./天气-雷阵雨伴有冰雹.png": "zR3Z",
	"./天气-雾.png": "PCa6",
	"./天气-霾.png": "BSWo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16bB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/天气\-.*\.png$
// module id = 16bB
// module chunks = 1